import { useContext } from "react";
import { NotificationPreferencesContext } from "../context/NotificationPreferencesContext";

/**
 * Read or change the signed-in user's notification preferences from anywhere.
 *
 * The state itself lives in context/NotificationPreferencesProvider.jsx; this is
 * the only supported way to reach it. The guard below is why: the context object
 * defaults to `undefined`, so a component rendered outside the provider gets a
 * named error instead of destructuring `undefined` somewhere further down.
 *
 * @returns {{
 *   newsSubscription: boolean,
 *   toggling: boolean,
 *   toggleNewsSubscription: () => Promise<void>,
 * }}
 */
export const useNotificationPreferences = () => {
  const context = useContext(NotificationPreferencesContext);

  if (context === undefined) {
    throw new Error(
      "useNotificationPreferences must be used inside <NotificationPreferencesProvider> (mounted in src/appProviders.jsx).",
    );
  }
  return context;
};
